const MQTT = {
  HOST: (typeof window !== 'undefined'
    ? window.location.origin.replace(/^http/, 'ws') + '/mqtt'
    : 'ws://localhost:9001'),
  OPTIONS: { qos: 0 },
};
module.exports = { MQTT };
